





































import Vue from 'vue';
import { mapState } from 'vuex';
import Header from '@root/common/components/layout/header/Header.vue';
import HeaderBottom from '@root/common/components/layout/header/HeaderBottom.vue';
import Footer from '@root/common/components/layout/footer/Footer.vue';
import { Header as IHeader, Footer as IFooter, Mobile as IMobile } from '@root/modules/navigation/types/navigation';
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';
import AdFormSiteheader from '@ads/components/adForm/AdFormSiteheader.vue';
import AdFormPromotionLine from '@ads/components/adForm/AdFormPromotionLine.vue';
import { WithContext, WebSite } from 'schema-dts';
import { ArticleAdapter } from '@root/modules/article/utils/ArticleAdapter';
import { getEnv } from '@root/common/utils/getEnv';
import cookieBot from '@root/common/utils/cookieBot';
import { gridConfig } from '@core/config/grid.config';
import getBannerKey from '@root/modules/ads/utils/getBannerKey';
import { formatAdSurround, resetFormatAdSurround } from '@root/modules/ads/utils/formatAdSurround';
import MobileHeader from '@root/common/components/layout/header/MobileHeader.vue';
import switchArticleLayout from '@root/views/article/utils/switchArticleLayout';

interface Computed {
  contentCenterClass: Record<string, boolean>;
  hideHeader: boolean;
  headerNavigation: IHeader;
  footerNavigation: IFooter;
  mobileNavigation: IMobile[];
  hideOrdering: boolean;
  pageContentLoaded: string;
  alerts: { type: string; title: string; text: string }[];
  adsPlacements: Record<string, any>;
  siteHeaderAd: string;
  mobileSiteHeaderAd: string;
  headerAd: Record<string, any>;
  floatingAd: Record<string, any>;
  scrollerAd: Record<string, any>;
  bottomAd: string;
  mobileinterstitialAd: string;
  isFrontpage: boolean;
  isArticle: boolean;
  isCrArticle: boolean;
  refetch: boolean;
}

interface Data {
  bannerKeys: Record<string, string>;
  isMobileView: boolean;
}

interface Methods {
  resetAdFormKey: (index?: number, skipHeader?: boolean) => void;
  copyUrlInject: () => void;
  getKey: (params: Record<string, any>) => string;
}

const pageFetchLogic = ['frontpage', 'channel', 'category', 'article', 'customPage'];

interface DefaultWindow extends Window {
  dataLayer: any;
  loginAction: any;
  switchArticleLayout: any;
}

declare const window: DefaultWindow;

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    AdFormSiteheader,
    AdFormBanner,
    AdFormPromotionLine,
    Header,
    HeaderBottom,
    Footer,
    MobileHeader,
  },
  data() {
    return {
      bannerKeys: {
        siteHeader: 'siteheader',
        header: 'header',
        floating: 'floating',
        mobileInterstitial: 'mobileInterstitial',
        bottom: 'bottom',
      },
      isMobileView: false,
    };
  },
  jsonld() {
    const { base } = this.$channelConfig('meta');
    const pageJsonld: WithContext<WebSite> = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: base.baseUrl,
      author: {
        '@type': 'Person',
        name: base.title,
      },
      publisher: {
        '@type': 'Organization',
        name: 'Delfi',
      },
      description: base.description,
    };
    return pageJsonld;
  },
  head() {
    const { lang } = this.$channelConfig('settings');
    const bodyClass = this.hideHeader ? 'no-header' : '';
    const link = [{ hid: 'login_app_css', rel: 'stylesheet', href: `${getEnv('loginAppBaseUrl')}/css/app.css` }];
    const script = [{ src: `${getEnv('loginAppBaseUrl')}/app.js`, async: true, defer: true }];

    return {
      htmlAttrs: {
        lang,
      },
      bodyAttrs: {
        class: bodyClass,
      },
      link,
      script,
    };
  },
  computed: {
    contentCenterClass() {
      const disabledAdsList: string[] = this.$store.getters['adForm/getDisabledAdsList'];
      return { 'C-content-center': disabledAdsList.includes('tower') };
    },
    hideHeader() {
      const { specialFeatures } = this.$channelConfig('settings').application;
      return specialFeatures.disableHeader;
    },
    ...mapState({
      headerNavigation: (state: any) => state.navigation.header.data as IHeader,
      footerNavigation: (state: any) => state.navigation.footer.data as IFooter,
      mobileNavigation: (state: any) => state.navigation.mobile.data as IMobile[],
    }),
    hideOrdering() {
      const { specialFeatures } = this.$channelConfig('settings').application;
      return specialFeatures.hideSignupAndOrders.enabled;
    },
    pageContentLoaded() {
      return this.$store.state.index.pageContentLoaded;
    },
    alerts() {
      return this.$store.state.index.alerts || [];
    },
    adsPlacements() {
      const ads: Record<string, any> = this.$store.getters['adForm/getAdsPlacements'];

      return ads || {};
    },
    siteHeaderAd() {
      return (this.adsPlacements.siteheader && this.adsPlacements.siteheader.mid[0]) || null;
    },
    mobileSiteHeaderAd() {
      return (this.adsPlacements.mobilesiteheader && this.adsPlacements.mobilesiteheader.mid[0]) || null;
    },
    headerAd() {
      const placement: Record<string, any> = { mid: null, adb: null };

      if (this.adsPlacements.header && this.adsPlacements.header.mid.length > 0 && this.adsPlacements.header.mid[0]) {
        placement.mid = this.adsPlacements.header.mid[0];
      }

      if (this.adsPlacements.header && this.adsPlacements.header.adb) {
        placement.adb = this.adsPlacements.header.adb;
      }

      return placement;
    },
    floatingAd() {
      const placement: Record<string, any> = { mid: null, adb: null };

      if (this.adsPlacements.floating && this.adsPlacements.floating.mid.length > 0 && this.adsPlacements.floating.mid[0]) {
        placement.mid = this.adsPlacements.floating.mid[0];
      }

      if (this.adsPlacements.floating && this.adsPlacements.floating.adb) {
        placement.adb = this.adsPlacements.floating.adb;
      }

      return placement;
    },
    scrollerAd() {
      const placement: Record<string, any> = { mid: null, adb: null };

      if (this.adsPlacements.scroller && this.adsPlacements.scroller.mid.length > 0 && this.adsPlacements.scroller.mid[0]) {
        placement.mid = this.adsPlacements.scroller.mid[0];
      }

      if (this.adsPlacements.scroller && this.adsPlacements.scroller.adb) {
        placement.adb = this.adsPlacements.scroller.adb;
      }

      return placement;
    },
    bottomAd() {
      return (this.adsPlacements.bottom && this.adsPlacements.bottom.mid[0]) || null;
    },
    mobileinterstitialAd() {
      return (this.adsPlacements.mobileinterstitial && this.adsPlacements.mobileinterstitial.mid[0]) || null;
    },
    isFrontpage() {
      return this.$route.name === 'frontpage';
    },
    isArticle() {
      return this.$route.name === 'article';
    },
    isCrArticle() {
      const activeArticle = this.$store.getters['article/getActiveArticle'];
      const crArticles = this.$store.getters['article/getCrArticles'];
      const isCrArticle = crArticles.find((article: number) => article === activeArticle.id);

      return this.isArticle && isCrArticle;
    },
    refetch() {
      return this.$store.state.frontpage.refetch;
    },
  },
  watch: {
    // asyncData logic - key will change after page asyncData has finished
    $route() {
      if (this.$route.name && !pageFetchLogic.includes(this.$route.name)) {
        this.resetAdFormKey();
      }

      resetFormatAdSurround();
    },
    // fetch logic - key will change after page fetch has finished
    pageContentLoaded() {
      if (this.$route.name && pageFetchLogic.includes(this.$route.name)) {
        if (this.isArticle && this.isCrArticle) {
          const activeArticle = this.$store.getters['article/getActiveArticle'];
          this.resetAdFormKey(activeArticle.id, true);
        } else {
          this.resetAdFormKey();
        }
      }
    },
    refetch(refetch) {
      if (refetch) {
        this.resetAdFormKey(Math.floor(10000 + Math.random() * 90000));
      }
    },
  },
  mounted() {
    if (process.client) {
      const screenWidth = window.screen.width;
      this.isMobileView = screenWidth <= gridConfig.breakpoints.lg;
    } else {
      this.isMobileView = this.$ua && this.$ua.deviceType() === 'smartphone' && !this.$ua.isFromTablet();
    }

    window.addEventListener('message', (event: MessageEvent) => {
      if (event.data === 'formatAdSurround') {
        formatAdSurround();
      }

      if (event.data.type === 'LoginAPI' && event.data.action === 'showLoginEmbed') {
        window.loginAction();
      }
    });

    this.$instanceConnector('customer').listenToCustomerLoginState();
    try {
      this.$instanceConnector('headlines').listen('headlineClick', async ({ headline }) => {
        const articleAdapter = new ArticleAdapter(headline, this.$channelConfig('page').article.component);
        const article = articleAdapter.adapt();
        this.$store.commit('adForm/setAdsRenderingState', false);
        this.$store.commit('article/setTempData', { article });
        this.$store.commit('article/setPreFetch', true);

        if (headline.clickData) {
          let crIndex = null;

          if (this.isArticle && this.isCrArticle) {
            const activeArticle = this.$store.getters['article/getActiveArticle'];
            const id = activeArticle.id;
            const crArticles = this.$store.state.article.crArticles;
            crIndex = crArticles.indexOf(id) + 1;
          }

          window.dataLayer.push({
            event: 'article_click',
            page_layout: headline.clickData.articleLayout,
            article_list_type: headline.clickData.listType,
            article_list_position: headline.clickData.listPosition,
            article_id: headline.clickData.listArticleId,
            article_url: headline.clickData.listArticleUrl,
            article_position: headline.clickData.listArticlePosition,
            article_index: this.isArticle && this.isCrArticle && crIndex ? crIndex : null,
          });
        }
      });
    } catch (e) {
      this.$sentry.captureException(`Headline click fail: ${e}`, {
        tags: { 'process.server': process.server ? 'server' : 'client' },
        contexts: { vue: { componentName: 'default.vue layout' } },
      });
    }

    if (process.client) {
      cookieBot(this.$channelConfig('settings').lang);
      this.copyUrlInject();
    }

    // Declare global switchArticleLayout util
    window.switchArticleLayout = switchArticleLayout;
  },
  methods: {
    getKey({ prefix, index }) {
      return getBannerKey({ prefix, route: this.$route, store: this.$store, index });
    },
    resetAdFormKey(index, skipHeader = false) {
      if (skipHeader) {
        this.bannerKeys = {
          ...this.bannerKeys,
          floating: this.getKey({ prefix: 'floating', index }),
          mobileInterstitial: this.getKey({ prefix: 'mobileinterstitial', index }),
        };
      } else {
        this.bannerKeys = {
          siteHeader: this.getKey({ prefix: 'siteheader', index }),
          header: this.getKey({ prefix: 'header', index }),
          floating: this.getKey({ prefix: 'floating', index }),
          mobileInterstitial: this.getKey({ prefix: 'mobileinterstitial', index }),
          bottom: this.getKey({ prefix: 'bottom', index }),
        };
      }
    },
    copyUrlInject() {
      if (!process.client || !window) {
        return;
      }

      window.document.addEventListener('copy', () => {
        const sel = window.getSelection();

        if (!sel || sel.anchorNode?.nodeName !== '#text' || sel.toString().length < 32) {
          return;
        }

        const isPaid = this.$store.getters['article/getActiveArticle']?.content.paywall.enabled || false;
        if (sel.toString().length > 100 && isPaid) {
          sel.removeAllRanges();
        }

        const loc = this.$t('copy_inject_url.message');
        const xtext = '<br/><br/> ' + loc + '<a href="' + document.location.href + '">' + document.location.href + '</a><br/><br/>';

        const div = window.document.createElement('div');
        div.innerHTML = sel + xtext;
        div.style.position = 'absolute';
        div.style.left = '-99999px';

        document.body.appendChild(div);

        sel.selectAllChildren(div);

        window.setTimeout(function() {
          div.remove();
        }, 0);
      });
    },
  },
});
